const permissionKeys: any = {
  // 首頁
  HOME: 1,
  HOME_RECENT_SCHEDULE: 2,
  HOME_OFFICE_SCHEDULE: 3,
  HOME_STUDENT_SCHEDULE: 4,
  HOME_MEDIA_SHARE: 5,
  HOME_DOCUMENT_SHARE: 6,
  HOME_MEDIA_SHARE_EDIT: 10,
  HOME_DOCUMENT_SHARE_NEW: 12,
  HOME_DOCUMENT_SHARE_EDIT: 13,
  HOME_DOCUMENT_SHARE_DELETE: 14,

  // 行事曆
  // 行事曆權限名稱請以 SCHEDULE_{Number}_{Action} 延伸下去命名
  // 1: 校務處, 2: 校務處, 3: 校務處, 4: 校務處, 5: 校務處, 6: 校務處
  SCHEDULE: 31,
  SCHEDULE_1_VIEW: 32, // 校務處
  SCHEDULE_1_NEW: 39,
  SCHEDULE_1_EDIT: 40,
  SCHEDULE_1_DELETE: 41,
  SCHEDULE_2_VIEW: 33, // 教務處
  SCHEDULE_2_NEW: 42,
  SCHEDULE_2_EDIT: 43,
  SCHEDULE_2_DELETE: 44,
  SCHEDULE_3_VIEW: 34, // 總務處
  SCHEDULE_3_NEW: 45,
  SCHEDULE_3_EDIT: 46,
  SCHEDULE_3_DELETE: 47,
  SCHEDULE_4_VIEW: 35, // 人事處
  SCHEDULE_4_NEW: 48,
  SCHEDULE_4_EDIT: 49,
  SCHEDULE_4_DELETE: 50,
  SCHEDULE_5_VIEW: 36, // 財務處
  SCHEDULE_5_NEW: 51,
  SCHEDULE_5_EDIT: 52,
  SCHEDULE_5_DELETE: 53,
  SCHEDULE_6_VIEW: 37, // 穰食堂
  SCHEDULE_6_NEW: 54,
  SCHEDULE_6_EDIT: 55,
  SCHEDULE_6_DELETE: 56,
  SCHEDULE_7_VIEW: 104, // 推廣中心
  SCHEDULE_7_NEW: 105,
  SCHEDULE_7_EDIT: 106,
  SCHEDULE_7_DELETE: 107,
  SCHEDULE_8_VIEW: 108, // 董事長室
  SCHEDULE_8_NEW: 109,
  SCHEDULE_8_EDIT: 110,
  SCHEDULE_8_DELETE: 111,
  SCHEDULE_9_VIEW: 112, // 校長室
  SCHEDULE_9_NEW: 113,
  SCHEDULE_9_EDIT: 114,
  SCHEDULE_9_DELETE: 115,
  SCHEDULE_10_VIEW: 116, // 校長室
  SCHEDULE_10_NEW: 117,
  SCHEDULE_10_EDIT: 118,
  SCHEDULE_10_DELETE: 119,
  SCHEDULE_IMPORT: 120,
  SCHEDULE_EXPORT: 121,

  // 請假系統
  LEAVE_SYSTEM: 57,
  LEAVE_SYSTEM_NEW: 58,
  LEAVE_SYSTEM_EDIT: 59,
  LEAVE_SYSTEM_DELETE: 60,

  // 自習名單
  ROLL_CALL: 61,
  ROLL_CALL_EDIT: 62,

  // 失物招領
  LOST_AND_FOUND: 63,
  LOST_AND_FOUND_NEW: 64,
  LOST_AND_FOUND_EDIT: 65,
  LOST_AND_FOUND_DELETE: 66,

  // 場地租借
  RENT_OUT_FIELD: 67,
  RENT_OUT_FIELD_NEW: 68,
  RENT_OUT_FIELD_EDIT: 69,
  RENT_OUT_FIELD_DELETE: 70,

  // 購買記錄
  BUY_RECORD: 71,
  BUY_RECORD_QUERY_ALL: 72,
  BUY_RECORD_EXPORT: 125,

  // 校車系統
  BUS: 73,
  BUS_NEW: 74,
  BUS_EDIT: 75,
  BUS_DELETE: 76,
  BUS_DETAIL: 122,

  // 物品租借
  RENT: 77,
  RENT_NEW: 78,
  RENT_EDIT: 79,
  RENT_DELETE: 80,

  // 售貨系統
  SALE: 81,
  SALE_NEW: 82,
  SALE_EDIT: 83,
  SALE_DELETE: 84,

  // 出勤系統
  ATTENDANCE: 85,
  ATTENDANCE_EDIT: 86,

  // 成績單管理
  TRANSCRIPT_MANAGEMENT: 126,
  TRANSCRIPT_MANAGEMENT_NEW: 127,
  TRANSCRIPT_MANAGEMENT_EDIT: 128,
  TRANSCRIPT_MANAGEMENT_DELETE: 129,

  // 人事管理
  HR_MANAGEMENT: 87,
  HR_MANAGEMENT_TEACHER: 88,
  HR_MANAGEMENT_TEACHER_NEW: 90,
  HR_MANAGEMENT_TEACHER_EDIT: 91,
  HR_MANAGEMENT_TEACHER_DELETE: 92,
  HR_MANAGEMENT_TEACHER_RESET_PASSWORD: 123,
  HR_MANAGEMENT_STUDENT: 89,
  HR_MANAGEMENT_STUDENT_NEW: 93,
  HR_MANAGEMENT_STUDENT_EDIT: 94,
  HR_MANAGEMENT_STUDENT_DELETE: 95,
  HR_MANAGEMENT_STUDENT_RESET_PASSWORD: 124,

  // 組織管理
  ORGANIZATION: 96,
  ORGANIZATION_CLASS_MANAGEMENT: 97,
  ORGANIZATION_CLASS_MANAGEMENT_NEW: 99,
  ORGANIZATION_CLASS_MANAGEMENT_EDIT: 100,
  ORGANIZATION_CLASS_MANAGEMENT_DELETE: 101,
  ORGANIZATION_PERMISSION_MANAGEMENT: 98,
  ORGANIZATION_PERMISSION_MANAGEMENT_EDIT: 102,
  ORGANIZATION_SEMESTER_MANAGEMENT: 130,
  ORGANIZATION_SEMESTER_MANAGEMENT_NEW: 131,
  ORGANIZATION_SEMESTER_MANAGEMENT_EDIT: 132,
  ORGANIZATION_SEMESTER_MANAGEMENT_DELETE: 133,
  ORGANIZATION_SUBJECT_MANAGEMENT: 134,
  ORGANIZATION_SUBJECT_MANAGEMENT_NEW: 135,
  ORGANIZATION_SUBJECT_MANAGEMENT_EDIT: 136,
  ORGANIZATION_SUBJECT_MANAGEMENT_DELETE: 137,

  // 封存紀錄
  ARCHIVED: 138,
  ARCHIVED_TRANSCRIPT: 139, 

  // 教室公告
  ANNOUNCEMENT: 103,
};

export default permissionKeys;